$(function() {
    'use strict';
    require('../modules/frontend-shell/base-integration');
    const frontendTrackingAgent = require('../modules/track_events/track.frontendevents.utils');

    const trackingUtils = require('../modules/utils/tracking.utils');
    const preSearch = require('../modules/helpers/pre_search');
    const paths = require('../modules/utils/generate_paths');
    const {setUsersResponseStateful} = require('../users_response_stateful');

    if (!App.Flights.checkCookies()) {
        return;
    }
    const searchExtensionTab = require('../modules/helpers/searchExtensionTab');
    const BuyPath = require('../modules/buy_path/buy_path');
    const BuyPathResults = require('../modules/buy_path/buy_path.results');
    const currentSearchSingletonModel = require('../modules/models/current_search.singleton.model');
    const $header = $('#header');
    /** START LOGIN */
    const tagManagement = require('../modules/utils/tag_management.utils');

    const toggleHeaderPrimeElements = (isMembership) => {
        const $diamondElements = $header.find('.od-golden-icon');
        const $bubbleElement = $header.find('.od-pill-prime');
        $diamondElements.toggleClass('odf-hidden', !isMembership);
        $bubbleElement.toggleClass('odf-hidden', !isMembership);
    };

    /** END LOGIN */
    let closeHeaderPopUps;
    const app = Odigeo.Utils.getAppInGlobalScope();
    const isSecure = 'https:' === Odigeo.Utils.getWebProtocol();
    const trackingNewSearch = require('../tracking/newsearchtracking')();
    const hideLoginBoxBlacklist = ['payment', 'xsellproductselection'];
    const hotelUtils = require('../modules/utils/hotel_utils');
    const {isRememberMeCookiePresent} = require('../sso_remember_me');

    const isDynpack = () => Odigeo.Utils.isRequestApp('dp');
    const isHotelsForPrime = () => Odigeo.AB.isHotelsForPrime;
    const isPrimeEnabled = () => Odigeo.AB.isPrimeEnabled;

    const toggleLoginBanner = function() {
        if (isHotelsForPrime() && isPrimeEnabled()) {
            const {isLogin} = hotelUtils.getLoginInfo();
            const $flightsManager = $('#flights-manager');
            const activeTab = $flightsManager.find('.flightsManager_tab.active').data('value');
            const $hotelLoginBanner = $flightsManager.find('.hotels_login_banner');
            if (!isLogin && 'hotels' === activeTab) {
                $hotelLoginBanner.removeClass('odf-hidden');
                $hotelLoginBanner.parent().removeClass('od-flights-manager-iframe-margin');
            } else {
                $hotelLoginBanner.addClass('odf-hidden');
                $hotelLoginBanner.parent().addClass('od-flights-manager-iframe-margin');
            }
        }
    };

    const setLoginCustomVars = (logged) => {
        Odigeo.trigger('analytics:tracking', {
            type: 'trackCustomVariable',
            data: {
                index: 50,
                name: 'SSO',
                value: 'SSO_' + (logged ? '1' : '0'),
                scope: 2,
                customDimension: 15,
            },
        });
    };

    // Override AJAX callbacks
    _.extend(
        Odigeo.Model.prototype,
        {
            pagesList: ['home', 'results', 'details', 'payment', 'confirmation'],
            seatmapSelectionWidget: {
                id: 'seatmap-selection-manager',
                name: 'seatmap_selection_manager',
            },
            error404() {
                Odigeo.Router.navigate('error');
            },
            error500() {
                Odigeo.UIElements.showBrokenFlowError();
            },
            defaultError() {
                Odigeo.UIElements.showBrokenFlowError('alert', true);
            },
            hideLoading() {
            },
        }
    );

    closeHeaderPopUps = function() {
        $header.find('.opened').removeClass('opened');
        $header.find('.more_options_up').addClass('odf-hidden');
        $header.find('.more_options_down').removeClass('odf-hidden');
    };

    Odigeo.on('notification:openLayer', function() {
        const state = 'true' === Odigeo.Session.get('messageOpen');

        if (Odigeo.SessionScope.openNotification && !state) {
            Odigeo.Session.set('messageOpen', 'true');
            const $launcher = $('.notification_layer');
            const noReturnBookerNotification = 0 < $launcher.find('.notification_message.returnbooker_bags_and_seats_message.odf-hidden').length;
            $launcher.trigger(Odigeo.Events.tap);

            if (noReturnBookerNotification) {
                setTimeout(function() {
                    if (0 === $('.notification_layer:hover').length) {
                        $launcher.trigger(Odigeo.Events.tap);
                    }
                }, 3000);
            }
        }
    });

    Odigeo.on('notification:closeHeaderDialogs', function() {
        $('.header_launcher').removeClass('opened');
    });

    // Ensure analytics-client-identification service is called after rentacar sets the _ga cookie
    setTimeout(() => {
        const {thirdPartyTracking} = require('@edreamsodigeo/frontend-tracking-agent');
        thirdPartyTracking?.identifyAnalyticsClient();
    }, 10000);

    Odigeo.start({
        settings: {
            isSearchExecuted: false,
            pathNames: {
                'home': Odigeo.Settings.property('appContext') + '/',
                'flights': Odigeo.Settings.property('appContext') + '/flights/',
                'dp': Odigeo.Settings.property('appContext') + '/dp/',
                'secure': '/travel/secure/',
                'support-area': '/travel/support-area/',
            },
            sessionExpirePages: [
            ],
            sessionExpirePagesOnLoad: [
            ],
            sessionAboutToExpirePages: [
            ],
            searchExpirePages: [
            ],
            sessionLoginExpirePages: [
            ],
        },

        onBeforeWidgetLoading() {
            // Check validity of Storage.
            const searches = Odigeo.Storage.get('search-data');
            const travellers = Odigeo.Storage.get('travellers');
            let purgedSearches;
            let purgedTravellers;

            if (!_.isNull(searches)) {
                purgedSearches = App.Flights.purgePreviousSearches(searches);
                Odigeo.Storage.set('search-data', JSON.stringify(purgedSearches));
            }

            if (!_.isNull(travellers)) {
                purgedTravellers = App.Flights.purgeTravellers(travellers);
                Odigeo.Storage.set('travellers', JSON.stringify(purgedTravellers));
            }
        },
        onStart() {
            let $el;
            let $current;
            let $subMenu;
            let trackEvent;
            let returnToHome;
            let $subMenuChild;
            let changeSubMenuIcon;
            let selectCurrentMenu;
            let switchHeaderIconsSelection;
            let getHeaderLinkTrackingLabel;

            const $page = $('#page');
            const $window = $(window);
            const $menus = $('.menu_list');
            const convertAppToIDPage = {
                home: 'home',
                dp: 'flighthotel',
                flights: 'flights',
            };

            const $menuBar = $header.find('.menu_bar');
            const convertedToIDPage = convertAppToIDPage[app];
            const usabillaEvents = require('../modules/usabilla/events');
            const pageNameFromFragment = Odigeo.History.getPageNameFromFragment();
            const metricFramework = 'LOAD_FRAMEWORK_STARTED';

            Odigeo.trigger('listenToLoginStatusChangesFromReact');

            trackingUtils.trackStop(metricFramework);
            trackingUtils.trackHomeContinuance();
            usabillaEvents();

            const openPage = function(e) {
                const $activeMenu = $menus.find('.current.menu_item');
                const $activeMenuPage = $activeMenu.data('view');
                const $activeMenuPageElement = $('#' + $activeMenuPage);
                frontendTrackingAgent.trackClickEvent(e);

                $el = $(e.currentTarget);
                const page = $el.data('page');
                const view = $el.data('view');
                const url = $el.data('url');

                if (!$el.hasClass('od-prime-visibility-no-padding')) {
                    e.stopImmediatePropagation();
                }
                if (!_.isEmpty(page) || !_.isEmpty(view) || !_.isEmpty(url)
                    || $el.hasClass('protocol_switch') || $el.children().hasClass('protocol_switch')) {
                    if (!_.isEmpty($activeMenuPage) && $activeMenuPageElement[0] && $activeMenuPageElement[0].beforeLeavePageHandler) {
                        $activeMenuPageElement[0].beforeLeavePageHandler();
                    } else {
                        pageRedirect();
                    }
                }
            };

            const displayMoreDropdown = function(e) {
                e.stopPropagation();
                const $container = $(this).siblings('.more_items_container');
                const isOpen = $container.hasClass('opened');

                closeHeaderPopUps();
                $(this).siblings('.more_items_container').toggleClass('opened', !isOpen);
                $(this).find('.more_options_down').toggleClass('odf-hidden', !isOpen);
                $(this).find('.more_options_up').toggleClass('odf-hidden', isOpen);

                trackEvent('header_more_menu');
            };

            const pageRedirect = function() {
                const page = $el.data('page');
                const url = $el.data('url');
                const target = $el.data('target');
                const selected = $el.attr('id');
                const pagesOF = [
                    'menu_home',
                    'menu_flights',
                    'menu_flighthotel',
                ];

                if ('myinfo' === $el.data('view')) {
                    // Dirty hack to allow click propagation reach the <a> tag before layout hides
                    _.delay(function() {
                        switchHeaderIconsSelection($el);
                    }, 400);
                } else if (!url) {
                    switchHeaderIconsSelection($el);
                }

                // Analytics: event tracking
                trackEvent(getHeaderLinkTrackingLabel($el));

                if (!_.isEmpty(page)) {
                    Odigeo.Router.navigate(page);
                } else if (!_.isEmpty(url)) {
                    if ('_blank' === target) {
                        Odigeo.trigger('analytics:tracking', {
                            type: 'sendToPageBlank',
                            data: {
                                url: url,
                                goOutside: !_.includes(pagesOF, selected),
                            },
                        });
                    } else {
                        Odigeo.trigger('analytics:tracking', {
                            type: 'sendToPageSelf',
                            data: {
                                url: url,
                                goOutside: !_.includes(pagesOF, selected),
                            },
                        });
                    }
                }
            };

            getHeaderLinkTrackingLabel = function($item) {
                let label;
                const index = $item.parent().index();

                const labelMap = {
                    0: 'flights',
                    1: 'hotels',
                    2: 'dynpack',
                    3: 'cars',
                    4: 'sejours',
                };

                label = labelMap[index];
                if (_.isUndefined(label)) {
                    label = index + '_' + Odigeo.Utils.replaceNonAlphaNumeric($item.text(), '', true);
                }

                return 'header_' + label;
            };

            switchHeaderIconsSelection = function($el) {
                $menus.find('.current').removeClass('current');
                $menus.find('.active').removeClass('active');
                $menus.find('.submenu').addClass('hidden');
                $el.addClass('current');
                changeSubMenuIcon($el);
            };

            changeSubMenuIcon = function($el) {
                const parent = $el ? $el.parent() : null;
                if ($subMenu) {
                    $subMenu.children('.menu_item_desc').remove();
                    $subMenu.removeClass('current').prepend($subMenuChild);
                    $subMenu.find('.menu_item').removeClass('hidden');
                    $subMenu = null;
                    $subMenuChild = null;
                }
                if (parent && parent.hasClass('submenu')) {
                    $subMenu = parent.parent();
                    $subMenuChild = $subMenu.children('.menu_item_desc').detach();
                    // Dirty hack to allow click propagation reach the <a> tag before layout hides
                    _.delay(function() {
                        $el.addClass('hidden');
                        $subMenu.prepend($el.children().clone()).addClass('current');
                    }, 500);
                }
            };

            selectCurrentMenu = function() {
                $current = $menus.find('#menu_' + convertedToIDPage);
                $current.addClass('current');
            };


            returnToHome = function() {
                if (isSecure && isDynpack()) {
                    Odigeo.Session.remove('before-page');
                    $('body').data('app', 'dp');
                }

                // Don't navigate if it's disabled
                if (!$(this).hasClass('disabled')) {
                    if ('true' !== $('#page').attr('data-waiting') && !$(this).data('webMasterPage')) {
                        Odigeo.Session.set('page', 'home');
                        Odigeo.Utils.goToApplicationHome();
                    } else if ($(this).data('webMasterPage')) {
                        window.location = Odigeo.Settings.property('appContext');
                    }
                }
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('header', 'header', 'logo_clicks');
            };

            $window.on('hashchange', function() {
                $('.dialog:visible').trigger('dialog:closeOnNavigate');
                $('#nag_container:visible').trigger('lightbox:closeOnNavigate');
            });

            $page
                .on(Odigeo.Events.tap, function(e) {
                    if (0 === $(e.target).closest('.prevent_close_on_tap').length) {
                        closeHeaderPopUps();
                    }
                })
                .on('toggle-waiting-page', function(event, isShow) {
                    $(this).attr('data-waiting', function() {
                        return isShow || null;
                    });
                });

            Odigeo.on('closeAllPopUps', function() {
                closeHeaderPopUps();
            });

            Odigeo.Session.set('lastRouteChange', JSON.stringify(null));
            Odigeo.Session.set('messageOpen', 'false');

            Odigeo.bind('routeChange', function(info) {
                Odigeo.trigger('close:' + info.from.name);
                Odigeo.Session.set('lastRouteChange', JSON.stringify(info));
            });

            $menus.on(Odigeo.Events.tap, '.menu_item', _.bind(openPage, this))
                .on(Odigeo.Events.tap, '.menu_more_item', displayMoreDropdown);

            if (!Odigeo.SessionScope.isBookingXSWhiteLabel) {
                $('#logo').on(Odigeo.Events.tap, returnToHome);
            }

            Odigeo.bind('pageRedirect', pageRedirect);
            Odigeo.bind('returnToHome', returnToHome);
            if ($menus.length) {
                selectCurrentMenu();
            }
            Odigeo.bind('fullStorage', function() {
                $('.home_main_layout').addClass('error');
            });

            Odigeo.on('page:beforeSwitch', function($toPage) {
                $page.removeClass(function(index, className) {
                    const waitingClass = 'waiting';
                    $(this).attr('class', 0 > className.indexOf(waitingClass) ? '' : waitingClass);
                }).addClass($toPage.attr('id'));
            });

            if ((false === $page.data('isSessionAlive')) &&
                _.includes(Odigeo.Settings.property('sessionExpirePagesOnLoad'), pageNameFromFragment)) {
                Odigeo.UIElements.showSessionExpiredError('alert', true);
            }

            Odigeo.Router.bindAnyRoute(function() {
                $('#login-wrapper').toggleClass('odf-hidden', _.includes(hideLoginBoxBlacklist, Odigeo.History.getPageNameFromFragment()));
            });

            // bind header/footer events
            $('.header_help_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('header', 'header', 'help_clicks');
            });
            $('.footer_conditions_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('footer', 'footer', 'terms_and_conditions_clicks');
            });

            $('.header_secondary_menu').off().on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();

                const index = $(this).index();
                const itemLabel = Odigeo.Utils.replaceNonAlphaNumeric($(this).text(), '', true);
                const label = 'header_more_' + index + '_' + itemLabel;

                trackEvent(label);
            });

            $('.od-notification-wrapper-item a').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('notification_center', 'header', 'notifications_center_notice_clicks');
            });

            $('.footer_bottom_link, .footer_bottom_links a').off().on(Odigeo.Events.tap, function(evt) {
                trackingUtils.trackEvent('footer', 'links_open_' +
                    Odigeo.Utils.removeBlankSpaces($(evt.target).text()).toLowerCase(), Odigeo.History.getPageNameFromFragment());
            });

            $header.find('.check_in_button').on(Odigeo.Events.tap, function() {
                trackingUtils.trackEvent('header', 'click_checkin_pag:home', Odigeo.History.getPageNameFromFragment());
                const isLogged = isRememberMeCookiePresent();
                location.href = isLogged ? paths.getMyTripsPath() : paths.getCheckInPath();
            });

            $header.find('.header_help').on(Odigeo.Events.tap, function() {
                trackingUtils.trackEvent('header', 'faq_clicks', Odigeo.History.getPageNameFromFragment());
            });

            $('.mmb_awareness_card').off().on(Odigeo.Events.tap, function(e) {
                const url = e.currentTarget.getAttribute('data-url');
                const card = e.currentTarget.getAttribute('data-card');
                const isLoggedUser = isRememberMeCookiePresent();
                const logged = isLoggedUser ? 'yes' : 'no';
                const label = `cs_widget-postbooking_click:${card}_logged:${logged}`;
                const path = isLoggedUser ? paths.getMyTripsPath() : paths.getMyTripsLoginPath();
                trackingUtils.trackEventWithCategory('home', 'cs_widget-postbooking', label);
                location.href = _.isEmpty(url) ? path : url;
            });

            // Bind header
            const $headLaunchers = $('.header_launcher', '.header_menu_list');
            const $notificationCenterBubble = Odigeo.UIElements.enhanceBubbleNotification($header.find('.header_notificationcenter_bubble'));

            _.each($headLaunchers, function(el) {
                const $el = $(el);
                const triggerEvt = $el.data('trigger');
                const $others = $headLaunchers.not($el);
                let $target;

                if ('hover' === triggerEvt) {
                    let timer = null;
                    $el.hover(function() {
                        clearTimeout(timer);
                        $el.addClass('opened');
                        $others.removeClass('opened');
                    }, function() {
                        timer = setTimeout(function() {
                            $el.removeClass('opened');
                        }, 150);
                    });
                } else {
                    $el.on(Odigeo.Events[triggerEvt], function(e) {
                        const $currentTarget = $(e.currentTarget);
                        if (!$currentTarget.hasClass('previoussearches_header')) {
                            $el.toggleClass('opened');
                        }
                        $others.removeClass('opened');
                        if (0 < $el.find(' + .header_tooltip_countries').length) {
                            $('.continent_header.unfolded').trigger(Odigeo.Events.tap);
                        }
                        if ($el.hasClass('notification_layer')) {
                            $notificationCenterBubble.trigger('hideBubble');
                            $target = $(e.target);
                            if ($target.hasClass('close_notification')) {
                                $target.parents('.notification_message').addClass('odf-hidden').removeClass('od-notification-message');
                                if (!$('.notification_message').is(':visible')) {
                                    $('.no_messages').removeClass('odf-hidden');
                                }
                            }

                            if ($el.hasClass('opened')) {
                                trackingUtils.trackEventWithCategory('notification_center', 'header', 'notification_center_open');
                            }
                        }
                        e.stopPropagation();
                    });
                }

                if (($target = $el.find('.header_dialog')).length || ($target = $el.next('.header_dialog')).length) {
                    $target.find('.header_tooltip_close').on(Odigeo.Events.tap, function() {
                        $el.removeClass('opened');
                    });
                }
            });

            Odigeo.on('loading:show', function(index, trackTimingCategory) {
                const funnelLegacy = Odigeo.Utils.getFunnelTrackingLegacy();
                // Tracking analytics for waiting pages
                Odigeo.requireWidget('google-analytics', 'googleanalytics', function(widget) {
                    const suffix = 'true' === Odigeo.Session.get('payment3ds') ? '-3dsecure' : '/' + index;
                    widget.execute('trackVirtualPage', {
                        page: 'waiting' + suffix,
                        funnel: true,
                        legacy: '/waitPage/paso' + index + funnelLegacy,
                    });
                    if (!_.isEmpty(trackTimingCategory)) {
                        widget.execute('startTiming', {
                            timingCategory: trackTimingCategory,
                        });
                    }
                });
                Odigeo.Session.set('payment3ds', false);
            });

            $('.initial_loader').addClass('hidden');

            Odigeo.trigger('checkNewsletterVisibility');

            const $notificationHeader = $page.find('#notification-header');
            const $noMessage = $notificationHeader.find('.no_messages');
            const $messages = $notificationHeader.find('.notification_message:visible');
            const messageCount = $messages.length;
            if (0 < messageCount) {
                $noMessage.addClass('odf-hidden');
            }

            // SSO
            trackEvent = function(label) {
                trackingUtils.trackEventWithCategory(Odigeo.Utils.getTrackingCategory(), 'header', label);
            };

            // END SSO

            Odigeo.trigger('analytics:tracking', {
                type: 'trackCustomVariable',
                data: {
                    index: 37,
                    name: 'Beta',
                    value: $page.data('beta'),
                    scope: 2,
                },
            });

            Odigeo.trigger('trackMainPageView');

            Odigeo.Session.set('isAccommodationPostBooking', false);

            if (isHotelsForPrime() && isPrimeEnabled()) {
                $menuBar.find('.menu_item_hotels').on(Odigeo.Events.tap, function() {
                    const trackingSuffix = hotelUtils.getTrackingSuffix();
                    trackingUtils.trackEventWithCategory(Odigeo.SessionScope.entryPoint, 'header',
                        `header_hotels_sce:${trackingSuffix}`);
                });
            }

            const metricLoadDesktop = 'LOAD_HOME_DESKTOP';
            trackingUtils.trackStop(metricLoadDesktop);
        },
        router: {
            routes: {}, // WARNING: these STRING routes will become regexps with leading ^ and trailing $.
            routeMatches: {
                home: /^\/?(?:(?:frontend-home\/(?:flights\/|dp\/))?home\/(.*)|frontend-home\/(?:flights\/|dp\/)?|\/?)$/,
                resident: /^\/?(?:frontend-home\/)?(?:flights\/)?resident\//,
                inspirational: /^\/?(?:frontend-home\/)?(?:flights\/)?inspirational\/(.*)/,
                dpresident: /^\/?(?:frontend-home\/dp\/)?dpresident\//,
                error: /\/?error\//,
            },

            /**
             * Apps with pages that change to other apps (funnel change)
             */

            appChangePages: {
                home: {
                    home: 'home',
                    dpresults: 'dp',
                    dpresident: 'dp',
                    register: 'secure',
                    frequentpassengers: 'secure',
                    accountcreditcards: 'secure',
                    accountpreferences: 'secure',
                    mytrips: 'secure',
                    mytripslogin: 'secure',
                },
                flights: {
                    register: 'secure',
                    frequentpassengers: 'secure',
                    accountcreditcards: 'secure',
                    accountpreferences: 'secure',
                    mytrips: 'secure',
                    mytripslogin: 'secure',
                },
                dp: {
                    results: 'flights',
                    dpresident: 'dp',
                    resident: 'flights',
                    register: 'secure',
                    frequentpassengers: 'secure',
                    accountcreditcards: 'secure',
                    accountpreferences: 'secure',
                    mytrips: 'secure',
                    mytripslogin: 'secure',
                },
                hotels: {
                    register: 'secure',
                    frequentpassengers: 'secure',
                    accountcreditcards: 'secure',
                    accountpreferences: 'secure',
                    mytrips: 'secure',
                    mytripslogin: 'secure',
                },
            },
            handlers: $.extend(Odigeo.Router.handlers, {
                userEventController: {
                    globalEvents: {
                        /** OF2 Login **/
                        'frontend-shell:loginSuccess': 'onLoginOF2Success',
                        'frontend-shell:referral-receiver-travel-credit:toggle': 'onReferralReceiverTravelCreditToggle',
                        /** React **/
                        'react:isUserLogged': 'onUserLogged',
                        'react:isUserNotLogged': 'onUserNotLogged',
                        'react:fireTagManagerSuccessLoginEvent': 'fireTagManagerSuccessLoginEvent',
                    },
                    eventHandlers: {
                        onUserNotLogged() {
                            toggleHeaderPrimeElements(false);
                            trackingUtils.setCustomDimension(76, '');
                            setLoginCustomVars(false);
                        },
                        onUserLogged(usersResponse, throwGlobal, event) {
                            const {membership: isMembership, pendingToCollect: isPendingToCollect, action} = usersResponse;
                            const isLoginOk = action === 'isLoggedInOk' || action === 'isPersistentLoginOk';
                            toggleHeaderPrimeElements(isMembership);

                            this.fireTagManagerSuccessLoginEvent(usersResponse?.userDTO?.email);
                            tagManagement.extendDatalayer({registered_user_id: usersResponse?.userDTO?.id});
                            trackingUtils.setCustomDimension(76, usersResponse?.userDTO?.id);
                            setLoginCustomVars(true);

                            if (isLoginOk && !Odigeo.Session.get('feedbackPrime') &&
                                isMembership && !isPendingToCollect && isPrimeEnabled() && !isDynpack()) {
                                if (Odigeo.Session.set('feedbackPrime', true)) {
                                    Odigeo.requireWidget('membership-login-welcome-back', 'membership_login_welcome_back', function(widget) {
                                        widget.execute('openLightBox');
                                    });
                               }
                            }
                            toggleLoginBanner();
                            setUsersResponseStateful(usersResponse);
                            Odigeo.trigger(!!throwGlobal || !event ? 'global:userLogged' : event, _.isObject(usersResponse) ? usersResponse : {});
                        },
                        onLoginOF2Success() {
                            Odigeo.Session.remove('feedbackPrime');
                        },
                        onReferralReceiverTravelCreditToggle(data) {
                            if (data?.isWidgetVisible) {
                                const $page = $('#page');
                                const $bannerCountdown = $page.find('#countdown_wrapper');
                                if (0 < $bannerCountdown.length) {
                                    $bannerCountdown.addClass('odf-hidden');
                                }
                                const $bannerCampaign = $page.find('#campaign_countdownstandarddownloadapp_container');
                                if (0 < $bannerCampaign.length) {
                                    $bannerCampaign.addClass('odf-hidden');
                                }
                            }
                        },
                        fireTagManagerSuccessLoginEvent(customerEmail) {
                            tagManagement.fireEvent('login_success', 'customer_email', customerEmail);
                        },
                    },
                },
                chatManagerEventController: {
                    globalEvents: {
                        'error-message-manager:validateChat': 'onValidateChat',
                        'error-message-manager:openChat': 'onOpenChat',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onValidateChat() {
                            Odigeo.requireWidget('chat-manager', 'chat_manager', function(widget) {
                                widget.execute('isChatAvailable');
                            });
                        },
                        onOpenChat(error) {
                            Odigeo.requireWidget('chat-manager', 'chat_manager', function(widget) {
                                widget.execute('openChat', error);
                            });
                        },
                    },
                },
                errorManagerEventController: {
                    globalEvents: {
                        'chat-manager:validChat': 'onValidChat',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onValidChat(valid) {
                        },
                    },
                },
                repriceManagerEventController: {
                    globalEvents: {
                    },
                    // implementation of events handlers
                    eventHandlers: {
                    },
                },
                searchFlightsEventController: {
                    // Global events will remain bound in any part of the application
                    globalEvents: {
                        'onelinebutton_search_manager:search': 'onSearch',
                        'inspirational-manager:search': 'onSearch',
                        'ipchange-search:dpSearch': 'onDynpackSearchFromFlights',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onSearch(data, resultPage, stringifierFun) {
                            let iatas;
                            let residentIATAs;
                            let internalSearchFlowConditions;
                            let sameCountry = false;
                            let residentZones = [];
                            const pageName = Odigeo.History.getPageNameFromFragment();
                            const $flightsManager = $('#flights-manager');
                            const isDynpackTabActive = 'dp' === $flightsManager.find('.flightsManager_tab.active').data('value') &&
                                    'xsellproductselection' !== pageName;

                            resultPage = _.isUndefined(resultPage) ? 'results' : resultPage;
                            const residentPage = 'results' === resultPage ? 'resident' : 'dpresident';
                            stringifierFun = _.isFunction(stringifierFun) ? stringifierFun : App.Flights.searchParamsStringify;

                            if (trackingNewSearch.isValidPaymentMethod(data.collectionMethod)) {
                                trackingNewSearch.setAction('searcher_' + (isDynpackTabActive ? 'dynpack' : 'flights'));
                                trackingUtils.trackEvent(trackingNewSearch.action, trackingNewSearch.getPayMethodLabel(data));
                            }

                            if ('home' === pageName && !isDynpackTabActive) {
                                delete data.checkInDate;
                                delete data.checkOutDate;
                            }

                            let params = _.clone(data);

                            // Set buyPath
                            const resultsHomeBuyPathBuilder = new BuyPathResults(
                                resultPage,
                                App.Dynpack.getHomeBuyPath(isDynpack(), isDynpackTabActive),
                                'FLIGHTS_HOME_SEARCH_FORM'
                            );

                            params.buyPath = {
                                'inspirational': new BuyPath('INSPIRATIONAL_SEARCH'),
                                '': resultsHomeBuyPathBuilder,
                                'home': resultsHomeBuyPathBuilder,
                                'flights': resultsHomeBuyPathBuilder,
                            }[pageName].build();

                            internalSearchFlowConditions = 'dpresults' === resultPage &&
                                ('' === pageName || 'flights' === pageName || 'home' === pageName);

                            if (internalSearchFlowConditions) {
                                params.internalSearch = internalSearchFlowConditions;
                            }

                            params.internalSearch = Odigeo.SessionScope.isFromAirlineWMP || params.internalSearch;

                            // Check if qualifies for resident discount
                            if (!params.isInspirationalSearch) {
                                Odigeo.requireWidget('resident-discount', 'residentdiscount', function(widget) {
                                    residentIATAs = widget.options.residentZones;

                                    if (!_.isEmpty(residentIATAs)) {
                                        iatas = _.chain(params.searchSegments)
                                            .map(function(seg) {
                                                sameCountry = ((seg.departure.countryCode === seg.destination.countryCode) ||
                                                (seg.departure.country === seg.destination.country));
                                                return [seg.departure.iata, seg.destination.iata];
                                            })
                                            .flatten()
                                            .uniq()
                                            .value();

                                        residentZones = _.chain(residentIATAs)
                                            .pick(iatas)
                                            .values()
                                            .flatten()
                                            .uniq()
                                            .value();
                                    }
                                });
                            }

                            if (!residentZones.length ||
                                (0 < params.numInfants + params.numChildren) ||
                                'multipleTrip' === params.type) {
                                params = _.omit(params, 'resident');
                            }

                            currentSearchSingletonModel.getInstance().set(params);

                            let options = '';
                            let page;

                            const searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
                            if (Odigeo.AB.isFlexibleDatesOWActive && searchParams && 'oneWayTrip' === searchParams.type) {
                                Odigeo.requireWidget('calendar-grid', 'calendar_grid', function(widget) {
                                    widget.execute('refreshData');
                                });
                            }

                            // Redirect to Resident Discount page
                            if (params.isInspirationalSearch) {
                                page = 'inspirational';
                            } else if (sameCountry && residentZones.length &&
                                ('multipleTrip' !== params.type) &&
                                (0 === params.numInfants + params.numChildren)) {
                                page = residentPage;
                            } else {
                                page = resultPage;
                                options = {
                                    params: stringifierFun(params),
                                    replace: pageName === resultPage,
                                    isSecured: false,
                                };
                                if ('dpresults' !== resultPage) {
                                    trackingUtils.trackPage('waiting/1');
                                }
                                'results' === page && Odigeo.AB.isPreSearch && preSearch(data, options.params ? options.params : '');
                            }
                            const newTabUrl = window.location.protocol + '//' + window.location.host +
                                '/travel/#' + page + '/' + (options.params ? options.params : '');
                            if (params.isNewTab) {
                                const tab = window.open(newTabUrl, '_blank');
                                searchExtensionTab.didTabClose(tab, 250).then(_.bind(function(hasClosed) {
                                    if (hasClosed) {
                                        window.location.href = newTabUrl;
                                    }
                                }, this));
                            } else if (page === resultPage) {
                                location.href = 'dpresults' === resultPage ?
                                    paths.getDPResultsPagePath(location.search, options.params) :
                                    paths.getResultsPagePath(location.search, options.params);
                            } else {
                                Odigeo.Router.navigate(page, options);
                                trackingUtils.trackEvent('searcher_flights', 'new_tab_continue');
                            }
                        },

                        onDynpackSearch(data) {
                            if (true !== data.newRoomFormat) {
                                _.extend(data, App.Accommodations.getPaxNumBasedOnRooms(data.rooms, data.numberOfRooms));
                            }
                            this.onSearch(_.omit(data, 'newRoomFormat'), 'dpresults', App.Dynpack.searchParamsStringify);
                        },

                        onFlightManagerSearch(data) {
                            this.onSearch(data);
                        },

                        onDynpackSearchFromFlights(data) {
                            _.extend(data, App.Accommodations.allocateRooms(data));
                            this.onSearch(_.omit(data, 'newRoomFormat'), 'dpresults', App.Dynpack.searchParamsStringify);
                        },

                        onAnalyticsTrackingEvents(fullData) {
                            if (fullData.buyPath && -1 < fullData.buyPath.indexOf('HOME')) {
                                // Analytics: event tracking
                                const page = isDynpack() ? 'dynpack_tab' :
                                    ('flights' === Odigeo.SessionScope.entryPoint ? 'flights_tab' : 'home');
                                trackingUtils.trackEvent('searcher_flights', 'number_pax_' + fullData.numAdults + '_' +
                                    fullData.numChildren + '_' + fullData.numInfants, page);

                                if (fullData.flexibleDates) {
                                    trackingUtils.trackEvent('searcher_flights', 'search_flexible_checked');
                                }
                                if (fullData.directFlightsOnly) {
                                    trackingUtils.trackEvent('searcher_flights', 'direct_flights_checked', page);
                                }
                            }
                        },

                        onTrackAutocomplete(data) {
                            const isDynpackTabActive = 'dp' === $('#flights-manager').find('.flightsManager_tab.active').data('value');
                            trackingUtils.trackEvent(data.action +
                                (isDynpackTabActive ? 'dynpack' : 'flights'), data.label, data.page);
                        },
                    },
                },
            }),
        },
    });
});
